import { useCompaniesStore } from 'src/store/useCompaniesStore'
import { useFetchGetCompanies } from '../companies/companies'
import { useFetchGetUsers } from '../users'
import { useUsersStore } from 'src/store/users'
import { useEffect } from 'react'

const ProtectedRequest = ({ children }) => {
  const fetchGetUsers = useFetchGetUsers()
  const fetchGetCompanies = useFetchGetCompanies()
  const { handleCompanies } = useCompaniesStore((state) => state)
  const { handleLoading, handleUsers } = useUsersStore((state) => state)

  const getCompanies = async () => {
    try {
      const response = await fetchGetCompanies.mutateAsync()
      const companiesParsed = response.results.map((company) => ({
        ...company,
        id: company.id,
        name: company.name,
        createdAt: company.created_at,
        updatedAt: company.updated_at,
      }))
      handleCompanies(companiesParsed)
    } catch (error) {
      console.error(error)
    }
  }

  const getUsers = async () => {
    try {
      handleLoading(true)
      const response = await fetchGetUsers.mutateAsync()
      const usersParsed = response.results.map((user) => ({
        id: user.id,
        email: user.email,
        username: user.username,
        groups: user.groups.name,
        firstName: user.first_name,
        lastName: user.last_name,
        isActive: user.is_active,
        lastAccess: user.last_access,
        lastAccessToken: user.last_access_token,
        phoneNumber: user.phone_number,
        companyClient: user.company_client,
      }))

      handleUsers(usersParsed)
    } catch (error) {
      console.error(error)
    } finally {
      handleLoading(false)
    }
  }

  useEffect(() => {
    getUsers()
    getCompanies()
  }, [])

  return <>{children}</>
}

export default ProtectedRequest
